import axios from 'axios';
import constants from '../../../constant';

const baseURL = constants.apiUrl;

const api = axios.create({ baseURL: baseURL });

// Set Authorization header dynamically on each request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export default api;
